import {useAtom} from 'jotai';
import {useGA4WithParams} from '@/hooks/tracking';
import {cadastralLayerAtom} from '@/map/atom';
import {ToolboxItemProps} from './';
import {ReactComponent as MenuIcon} from './assets/cadastral.svg';
import {ToolboxItem} from './StyledComponents';

export const CadastralButton = (props: ToolboxItemProps) => {
  const [activeCadastral, setCadastralLayer] = useAtom(cadastralLayerAtom);
  const tracking = useGA4WithParams();

  const handleClick = () =>
    setCadastralLayer((prev) => {
      const next = !prev;
      if (next) {
        tracking('cadmap');
      }
      return next;
    });

  return (
    <ToolboxItem {...props} active={activeCadastral} onClick={handleClick}>
      <MenuIcon />
    </ToolboxItem>
  );
};
